import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BackendService } from '../core/backend.service';
import { LoadCatalogError, LoadCatalogSuccess } from '../root-store/catalog-store/actions';
import { selectCatalog } from '../root-store/catalog-store/selectors';
import { CatalogState } from '../root-store/catalog-store/state';
import { RootState } from '../root-store/root-state.model';
import { CatalogResponse } from './catalog.model';
import { SettingsReader } from './settings';
import { isGuid } from './utilities';

@Injectable({ providedIn: 'root' })
export class CatalogResolver implements Resolve<CatalogState | null> {
  constructor(
    private store: Store<RootState>,
    private backend: BackendService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    // if a catalog is already loaded, don't load it again
    let existingCatalog = this.store.selectSignal(selectCatalog)()

    if (existingCatalog?.id)
      return of(existingCatalog)

    let catalog$: Observable<CatalogResponse>
    if (route.params['catalog'])
      catalog$ = this.backend.getCatalog(route.params['catalog'])
    else if (route.params['OrderIdStatus'])
      catalog$ = this.backend.getCatalogByOrderId(route.params['OrderIdStatus'])
    else {
      const url0Path = route.url.length > 0 ? route.url[0].path : route.pathFromRoot[1].url[0].path
      catalog$ = isGuid(url0Path) ? this.backend.getCatalogByOrderId(url0Path) : this.backend.getCatalog(url0Path)
    }

    return catalog$.pipe(
      map(CatalogResolver.prepareCatalogModel),
      tap(catalog => {
        this.store.dispatch(LoadCatalogSuccess({ catalog }))
      }),
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 404) {
          if (!route.params['catalog'] && route.url[0].path)
            this.store.dispatch(LoadCatalogError({ error: 'OrderNotFound' }))
          else
            // redirect when the catalog is not found
            window.location.href = 'https://www.2reserve.ch'
        }
        else
          console.error('error loading catalog', error)

        return of(null)
      })
    )
  }

  static prepareCatalogModel(catalog: CatalogResponse): CatalogState {
    return {
      ...catalog,
      settings: new SettingsReader(catalog.settings).getSettings()
    }
  }
}
